import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function Contact({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Contact</b>
          </p>
          <p>
            Contact information is structured as:
            <pre>
              <code>
                {`
{
  "title": string,
  "firstName": string,
  "middleName": string,
  "lastName": string,
  "suffix": string
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
Contact.propTypes = {
  type: PropTypes.string.isRequired
};
